<app-error-page *ngIf="(hasError$ | async)"></app-error-page>
<app-spinner-loader *ngIf="(loader$ | async)?.isLoading"
                    [openingTvShop]="(loader$ | async)?.openingTvShop"
                    [descriptionSpinner]="(loader$ | async)?.description"></app-spinner-loader>
<app-maintenance-page *ngIf="isMaintenanceModeActive"
                      [maintenanceModeConfig]="maintenanceModeConfig"></app-maintenance-page>
<router-outlet *ngIf="!isMaintenanceModeActive && (isInitiated$ | async)"></router-outlet>
